<div class="opened-orders-actions">
	<app-button
		appearance="secondary"
		size="m"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.ORDER_DETAILS"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="detailsDropdown"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.ORDER_DETAILS"
		(clicked)="toggleDropdown(dropdownVariantEnum.ORDER_DETAILS)"
	>
		{{ 'orders.info' | translate }}
	</app-button>

	@if (checkCanEdit) {
		<app-button
			appearance="secondary"
			size="m"
			[isDisabled]="openedDropdown() === dropdownVariantEnum.ORDER_CHANGE"
			[tuiDropdownMinHeight]="600"
			[tuiDropdownMaxHeight]="600"
			[tuiDropdown]="changeDropdown"
			[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.ORDER_CHANGE"
			(clicked)="toggleDropdown(dropdownVariantEnum.ORDER_CHANGE)"
		>
			{{ 'orders.edit' | translate }}
		</app-button>
	}

	@if (checkCanCancel) {
		<app-button
			appearance="secondary"
			size="m"
			[isDisabled]="openedDropdown() === dropdownVariantEnum.ORDER_CANCEL"
			[tuiDropdownMinHeight]="600"
			[tuiDropdownMaxHeight]="600"
			[tuiDropdown]="cancelDropdown"
			[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.ORDER_CANCEL"
			(clicked)="toggleDropdown(dropdownVariantEnum.ORDER_CANCEL)"
		>
			{{ 'orders.cancel' | translate }}
		</app-button>
	}
</div>

<ng-template #changeDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-change-order
			[order]="order()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #cancelDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-cancel-order
			[order]="order()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #detailsDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-order-info-card
			[order]="order()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
